
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonNavigation from '@/components/molecules/ButtonNavigation.vue'

/**
 * インフォメーションパネルのメインメニュー
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
    ButtonNavigation,
  },
})
export default class InformationPanelMain extends Vue {
  /** 新着お知らせの有無 */
  @Prop()
  private hasNewNotice!: boolean

  /** お知らせボタン押下時の遷移先 */
  @Prop()
  private noticeUrl!: string

  /** 生徒ボタン押下時のイベント */
  @Prop()
  private eventClickStudentButton!: () => void

  /** 画面表示モードボタン押下時のイベント */
  @Prop()
  private eventClickToggleViewModeButton!: () => void

  /** インフォメーションパネルの開閉管理 */
  private isClose: boolean = true

  /**
   * インフォメーションパネルの状態を切り替える
   */
  private togglePanel(): void {
    this.isClose = !this.isClose
  }
}
